import React from 'react';
import Box from '@mui/material/Box';
import styled from '@mui/system/styled';
import Typography from '@mui/material/Typography';
import ArrowBack from '@mui/icons-material/ArrowBack';

const BackButton = ({text, onClick, sx}) => {
  return (
    <Container display="flex" alignItems="center" onClick={onClick} sx={sx}>
      <ArrowBack />
      {!!text && (
        <Typography fontWeight="bold" ml="0.6rem">
          {text}
        </Typography>
      )}
    </Container>
  );
};

const Container = styled(Box)`
  cursor: pointer;
`;

export default BackButton;
